import { dataExplorer, schemaExplorer } from './initial-state';
import { StoreState } from './types';

const initialState: StoreState = {
  schemaExplorer,
  dataExplorer
};

export default initialState;
